module.exports = __webpack_public_path__ + "img/consult_info2.bf95d39d.png";